import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StripeService {

  constructor(private http: HttpClient) { }

  cancelPlan(): Observable<any> {
    const url: string = `${environment.apiUrl}/stripe/customer/cancel-subscription`;
    return this.http.post(url, {})
  }
}
